import React from "react";
import { Tab, Tabs } from "@mui/material";
import { Outlet, useMatch, useNavigate } from "react-router-dom";

interface Props {}
const ScheduledReportsManagement: React.FC<Props> = () => {
  const type = useMatch("admin-panel/scheduled-reports-management/templates") ? "templates" : "subscriptions";
  const navigate = useNavigate();

  function redirectTab(tab: string) {
    navigate(tab, { replace: true });
  }

  return (
    <div className="page--container">
      <Tabs value={type} onChange={(_, value) => redirectTab(value)}>
        <Tab value="templates" label="Templates" />
        <Tab value="subscriptions" label="Subscriptions" />
      </Tabs>
      <Outlet />
    </div>
  );
};

export default ScheduledReportsManagement;
